import { render, staticRenderFns } from "./TicketItem.vue?vue&type=template&id=638022dc&scoped=true&"
import script from "./TicketItem.vue?vue&type=script&lang=js&"
export * from "./TicketItem.vue?vue&type=script&lang=js&"
import style0 from "./TicketItem.vue?vue&type=style&index=0&id=638022dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638022dc",
  null
  
)

export default component.exports